import { useCallback, useEffect, useState } from "react";
import { container } from "tsyringe";
import ForumPostResponseResource from "common/resources/Project/Config/Forum/ForumPostResponseResource";
import I18n from "components/materials/I18n";
import PageTemplate from "components/PageTemplate";
import { usePostId } from "hooks/usePostId";
import { useProjectId } from "hooks/useProjectId";
import ForumPostService from "services/projects/ForumPostService";
import { ProjectProvider } from "../FeaturedProjects/contexts/Project";
import { CommentSection } from "./components/CommentSection";
import ReturnButton from "./components/ReturnButton";
import PostHeader from "./components/PostHeader";
import classes from "./classes.module.scss";

const forumPostService = container.resolve(ForumPostService);

export default function ForumPost() {
	const { post } = usePost();

	return (
		post && (
			<ProjectProvider>
				<PageTemplate tabTitle={I18n.trslt(I18n.asset.pages.post.title)}>
					<div className={classes["root"]}>
						<ReturnButton />
						<PostHeader post={post} />
						<CommentSection />
					</div>
				</PageTemplate>
			</ProjectProvider>
		)
	);
}

const usePost = () => {
	const { projectId } = useProjectId();
	const { postId } = usePostId();
	const [post, setPost] = useState<ForumPostResponseResource | null>(null);

	const fetchPost = useCallback(async () => {
		forumPostService.getById(projectId, postId).then(setPost);
	}, [postId, projectId]);

	useEffect(() => {
		fetchPost();
	}, [fetchPost]);

	return { post };
};
